import React from "react";
import AlertFill from "../../icons/Alert_Fill";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const FallbackError = () =>
{
  const { t } = useTranslation();
  const { uiTheme } = useSelector((state) => state.activation);
  return (
    <div className="pagination-view">
      <div className="row text-body">
        <div className="display-flex">
          <span style={{ height: 40, width: 40 }}><AlertFill fill={uiTheme.buttonColour}/></span>
          <div className="mar-none">
            <p className="mar-none">{t('fallbackErrorScreen.somethingWentWrong')}</p>
            <p className="margin-tp-16">{t('fallbackErrorScreen.tryAgain')}&nbsp;{t('fallbackErrorScreen.contactAdministrator')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FallbackError;
